import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from '../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessUserService {
  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public list(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'business-users/list', data);
  }

  public detail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'business-users/' + id);
  }

  public delete(id: any): Observable<any> {
    return this._httpClient.delete(this.url + 'business-users/' + id);
  }

  public create(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'business-users', data);
  }

  public update(data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'business-users/' + data.id, data);
  }

  public generate_qrcode(): Observable<any> {
    return this._httpClient.get(this.url + 'business-users/generate-code');
  }

  public getQrSite(): Observable<any> {
    return this._httpClient.get(this.url + 'business-users/qr-site');
  }

  public updateQrSite(data: {enabled: boolean; url?: string}): Observable<any> {
    return this._httpClient.patch(this.url + 'business-users/qr-site', data);
  }

  public detail_logo(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'business-users/' + id + '/name');
  }
}

